import { Stack } from '@mui/material';
import { BoardViewMode } from '../../../../config';
import { Button } from '@/components/ui/button';
import Icon from '@/units/Icon';

type Props = {
  mode: BoardViewMode;
  onChange?: (mode: BoardViewMode) => void;
};

export function ViewSwitch({ mode, onChange }: Props) {
  const isWeekMode = mode === BoardViewMode.Week;

  return (
    <Stack direction="row">
      <Button
        sx={{
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
          borderRight: 'none',
          color: isWeekMode ? '#1D2939' : '#667085',
          px: '16px',
          minWidth: '0',
          height: '44px',

          transition: 'color 0.15s ease',
          '@container board-content (max-width: 1440px)': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& .button-text': {
              display: 'none',
            },
          },
        }}
        onClick={() => onChange?.(BoardViewMode.Week)}
      >
        <Icon.Columns
          sx={{
            fontSize: '20px',
            color: isWeekMode ? '#2055FF' : '#667085',
            transition: 'color 0.15s ease',
          }}
        />
        <span className="button-text">Week</span>
      </Button>

      <Button
        sx={{
          borderTopLeftRadius: '0px',
          borderBottomLeftRadius: '0px',
          borderLeftWidth: '0px !important',
          color: !isWeekMode ? '#1D2939' : '#667085',
          transition: 'color 0.15s ease',
          height: '44px',
          minWidth: '0',
          px: '16px',
          '@container board-content (max-width: 1440px)': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '& .button-text': {
              display: 'none',
            },
          },
        }}
        onClick={() => onChange?.(BoardViewMode.List)}
      >
        <i
          className="fa-regular fa-list-ul"
          style={{
            display: 'block',
            fontSize: '20px',
            color: !isWeekMode ? '#2055FF' : '#667085',
            transition: 'color 0.15s ease',
          }}
        />
        <span className="button-text">List</span>
      </Button>
    </Stack>
  );
}
